import { forwardRef } from "react";
import styles from "./PageName.module.scss";

const PageName = forwardRef((props, ref) => {
  const { title } = props || {};

  return (
    <div className={styles.label} ref={ref}>
      {title}
    </div>
  );
});

export default PageName;
